import { render, staticRenderFns } from "./SelectCompanyProductAttributeValue.vue?vue&type=template&id=f65bad80&"
import script from "./SelectCompanyProductAttributeValue.vue?vue&type=script&lang=js&"
export * from "./SelectCompanyProductAttributeValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports